@import '@alfalab/core-components-vars/src/index.css';
@import '../vars.css';

.component {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: var(--pass-code-height);
}
